import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Component, HostListener, Input } from '@angular/core';

import { PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';
import { Card } from '@frk/eds-components';
import { LinkService } from '@services/link.service';
import { TitleTheme } from '@frk/eds-components';

@Component({
  selector: 'ft-media-cards-section',
  templateUrl: './media-cards-section.component.html',
  styleUrls: ['./media-cards-section.component.scss'],
})
export class MediaCardsSectionComponent implements SectionComponent {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  /**
   * Page Section content
   */
  content: PageSectionContent;

  /**
   * Display type
   */
  sectionType: string;

  /**
   * Cards Array
   */
  cards: Array<any>;

  /**
   * Number of Columns
   */
  columns = 3;

  theme: string;

  titleColorTheme: TitleTheme = 'basic';

  // if need to show four columns in a row
  @Input() showAllInRow = false;

  constructor(private ctaLinkService: LinkService) {}

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string
  ) {
    this.component = component;
    this.page = page;
    this.sectionType = sectionType;
    this.content = content;
    this.titleColorTheme =
      this.component?.getParameters()?.titleColor || 'basic';
    this.showAllInRow = component.getParameters()?.showAllInRow;
    if (this.content?.cards) {
      if (this.content.cards.length === 2) {
        this.columns = 2;
      }

      if (this.content.cards.length === 4 && this.showAllInRow) {
        this.columns = 4;
      } else if (this.content.cards.length === 4) {
        this.columns = 2;
      }

      if (this.content.cards.length >= 5) {
        this.columns = 3;
      }
      this.cards = this.createCardGroups(this.content.cards);
      this.cards = this.formatCardURL(this.cards.flat());
      this.theme = theme || 'primary';
    }
  }

  /**
   * Split cards into groups
   * @param cards - cards array
   */
  createCardGroups(array) {
    const cardGroups = [];
    let index = 0;
    while (index < array.length) {
      cardGroups.push(array.slice(index, this.columns + index));
      index += this.columns;
    }
    return cardGroups;
  }

  private formatCardURL(cards): Card[] {
    const newCards: Card[] = [];
    for (const card of cards) {
      newCards.push({
        ...card,
        href: this.ctaLinkService.getHref(this.page, card?.link, null),
      });
    }
    return newCards;
  }

  setDownloadLocation(event) {
    this.ctaLinkService.setUpdatedLinkData(event);
  }
}
